const AutoraJS = {
  // Main init function
  init: function () {
    this.config()
    this.events()
  },

  // Define vars for caching
  config: function () {
    this.config = {
      $window: $(window),
      $document: $(document),
    }
  },

  // Events
  events: function () {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this

    // Run on document ready
    self.config.$document.ready(function () {
      // PreLoader
      self.preLoader()

      // Header Fixed
      self.headerFixed()

      // Mobile Navigation
      self.mobileNav()

      // Scroll to Top
      self.scrollToTop()

      self.flatSpacer()

      self.flatContentBox
    })
  },

  // PreLoader
  preLoader: function () {
    $('#layout-loader').delay(1000).fadeOut(500)
  },

  // Header Fixed
  headerFixed: function () {
    if ($('div').hasClass('header-fixed')) {
      setTimeout(() => {
        var nav = $('#site-header')

        if (nav.length) {
          var offsetTop = nav.offset().top,
            headerHeight = nav.height(),
            injectSpace = $(`<div style="height: ${headerHeight}px; display: none;" />`).insertAfter(nav)

          var scrollFunction = function () {
            var nav = $('#site-header')
            if ($(window).scrollTop() > offsetTop) {
              nav.addClass('is-fixed')
              injectSpace.show()
            } else {
              nav.removeClass('is-fixed')
              injectSpace.hide()
            }

            if ($(window).scrollTop() > 100) {
              nav.addClass('is-small')
            } else {
              nav.removeClass('is-small')
            }
          }

          $(window).on('load', scrollFunction)
          $(window).on('scroll', scrollFunction)
        }
      }, 2000)
    }
  },

  // Mobile Navigation
  mobileNav: function () {
    var navFunction = function () {
      var mode = 'desktop'
      var wrapMenu = $('#site-header-inner .wrap-inner')
      var navExtw = $('.nav-extend.active')
      var navExt = $('.nav-extend.active').children()

      if (matchMedia('only screen and (max-width: 1199px)').matches) mode = 'mobile'

      if (mode === 'mobile') {
        $('#main-nav')
          .attr('id', 'main-nav-mobi')
          .appendTo('#site-header')
          .hide()
          .children('.menu')
          .append(navExt)
          .find('li:has(ul)')
          .children('ul')
          .removeAttr('style')
          .hide()
          .before('<span class="arrow"></span>')
      } else {
        if ($('div').is('.header-style-3')) wrapMenu = $('.site-navigation-wrap .inner')

        $('#main-nav-mobi')
          .attr('id', 'main-nav')
          .removeAttr('style')
          .prependTo(wrapMenu)
          .find('.ext')
          .appendTo(navExtw)
          .parent()
          .siblings('#main-nav')
          .find('.sub-menu')
          .removeAttr('style')
          .prev()
          .remove()

        $('.mobile-button').removeClass('active')
      }
    }
    $(window).on('resize', navFunction)
    $(window).on('load', navFunction)
    $(window).on('DOMSubtreeModified', navFunction)

    $(document).on('click', '.mobile-button', function () {
      $(this).toggleClass('active')
      $('#main-nav-mobi').slideToggle()
    })

    $(document).on('click', '#main-nav-mobi .arrow', function () {
      $(this).toggleClass('active').next().slideToggle()
    })
  },

  // Scroll to Top
  scrollToTop: function () {
    var scrollFunction = function() {
      if ($(this).scrollTop() > 100) {
        $('#scroll-top').addClass('show')
      } else {
        $('#scroll-top').removeClass('show')
      }
    }

    $('#scroll-top').on('click', function () {
      $('html, body').animate({ scrollTop: 0 }, 1000)
      return false
    })

    $(window).on('scroll', scrollFunction)
  },

  // Spacer append (.themesflat-spacer classes)
  flatSpacer: function () {
    const spacerFunction = function () {
      let mode = 'desktop'
      if (matchMedia('only screen and (max-width: 991px)').matches) mode = 'mobile'
      if (matchMedia('only screen and (max-width: 767px)').matches) mode = 'smobile'
      $('.themesflat-spacer').each(function () {
        if (mode === 'desktop') {
          $(this).attr('style', 'height:' + $(this).data('desktop') + 'px')
        } else if (mode == 'mobile') {
          $(this).attr('style', 'height:' + $(this).data('mobile') + 'px')
        } else {
          $(this).attr('style', 'height:' + $(this).data('smobile') + 'px')
        }
      })
    }

    $(window).on('load', spacerFunction)
    $(window).on('resize', spacerFunction)
    $(window).on('DOMSubtreeModified', spacerFunction)
  },

  // Content box margin change (.themesflat-content-box classes)
  flatContentBox: function () {
    const contentBoxFunction = function () {
      let mode = 'desktop'
      if (matchMedia('only screen and (max-width: 1199px)').matches) mode = 'mobile'
      $('.themesflat-content-box').each(function () {
        const margin = $(this).data('margin')
        if (margin) {
          if (mode === 'desktop') {
            $(this).attr('style', 'margin:' + $(this).data('margin'))
          } else if (mode === 'mobile') {
            $(this).attr('style', 'margin:' + $(this).data('mobilemargin'))
          }
        }
      })
    }
    $(window).on('load', contentBoxFunction)
    $(window).on('resize', contentBoxFunction)
    $(window).on('DOMSubtreeModified', contentBoxFunction)
  },
}

export { AutoraJS }
